import { V3Button } from "../Button";
import { V3ButtonColor } from "../Button/V3Button.types";
import { ItemPreview, ItemPreviewProps, ItemPreviewVariant } from "../ItemPreview";
import { ContentItemPreviewLearnMore } from "../ReusableStyledComponents/ContentItemPreviewLearnMore";
import { V3BodyGrey48 } from "../ReusableStyledComponents/V3BodyGrey48";
import { ConfirmationModalBtnPanel } from "../V3ConfirmationModal/V3ConfirmationModal.styles";
import { V3ModalBase } from "../V3ModalBase";
import { VerticalSpacing } from "../VerticalSpacing";

interface ModalCheckPreviewProps extends Omit<ItemPreviewProps, "isEmpty"> {
    setModalOpen: (open: boolean) => void,
    modalOpen: boolean,
    onPreviewEdit: () => void
}

export const ModalCheckPreview = ({ setModalOpen, onPreviewEdit, modalOpen, date, sourceName, originalUrl, contentType, imageSrc, title, description, showMetaContent }: ModalCheckPreviewProps) => {

    const isEmpty = !title?.length && !description?.length && !imageSrc?.length;

    return <V3ModalBase
        isOpen={modalOpen}
        onClose={() => { setModalOpen(false) }}
        title="Do you want to edit the preview?"
        width="550px"
    >
        <VerticalSpacing bottom={24}>
            <V3BodyGrey48>Your changes to the content item have been saved. You can also make changes to the preview if you like (see the current preview below). <ContentItemPreviewLearnMore /></V3BodyGrey48>
        </VerticalSpacing>
        <VerticalSpacing bottom={48}>
            <ItemPreview
                date={date}
                sourceName={sourceName}
                originalUrl={originalUrl}
                contentType={contentType}
                isEmpty={isEmpty}
                imageSrc={imageSrc}
                title={title}
                description={description}
                showMetaContent={showMetaContent}
                variant={ItemPreviewVariant.Secondary}
            />
        </VerticalSpacing>
        <ConfirmationModalBtnPanel>
            <div>
                <V3Button
                    text={"Continuing without editing"}
                    autoWidth
                    color={V3ButtonColor.secondary}
                    onClick={() => {
                        setModalOpen(false);
                    }}
                />
            </div>
            <div>
                <V3Button
                    text={"Edit preview"}
                    autoWidth
                    color={V3ButtonColor.primary}
                    onClick={onPreviewEdit}
                />
            </div>
        </ConfirmationModalBtnPanel>
    </V3ModalBase>
}